import { faSitemap } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import func from "../../services/functions";

// Empty State Component (consistent with Dashboard)
const EmptyState = ({ icon, title, text, compact = false, inline = false }) => (
  <div className={`db-empty ${compact ? "db-empty--compact" : ""} ${inline ? "db-empty--inline" : ""}`}>
    <div className="db-empty__icon">
      <FontAwesomeIcon icon={icon} />
    </div>
    {inline ? (
      <div className="db-empty__content">
        <div className="db-empty__title">{title}</div>
        {text && <div className="db-empty__text">{text}</div>}
      </div>
    ) : (
      <>
        <div className="db-empty__title">{title}</div>
        {text && <div className="db-empty__text">{text}</div>}
      </>
    )}
  </div>
);

const TcrCashBalance = ({ title, stats = [], sessionData, loading }) => {
  const { t } = useTranslation("translations");

  // Filter by business unit if selected
  let filteredStats = useMemo(() => {
    let result = sessionData?.businessUnitCode
      ? stats?.filter(
          (stat) => stat?.businessUnitCode === sessionData?.businessUnitCode
        )
      : stats;

    // Filter out technical TCR (TS001NC001)
    return result?.filter(stat => stat?.tcrCode !== "TS001NC001");
  }, [sessionData?.businessUnitCode, stats]);

  return (
    <div className="db-card db-tcr-balance-card">
      <h3>{title}</h3>
      {loading ? (
        // Loading skeleton
        <div className="db-tcr-balance-skeleton">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="db-tcr-item-skeleton">
              <div className="shimmer db-tcr-skeleton__badge" />
              <div className="shimmer db-tcr-skeleton__code" />
            </div>
          ))}
        </div>
      ) : filteredStats?.length > 0 ? (
        <div className="db-tcr-balance-list">
          {filteredStats?.map((stat) => {
            const balance = (stat?.cashEnd ?? 0) + (stat?.banknoteCashTot ?? 0);
            return (
              <div key={stat.tcrCode} className="db-tcr-item">
                <div className="db-tcr-item__amount">
                  {func.getFormattedMoneyValue(balance)} L
                </div>
                <div className="db-tcr-item__code">
                  <FontAwesomeIcon icon={faSitemap} className="db-tcr-item__icon" />
                  {stat?.tcrCode ?? "N/A"}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <EmptyState
          icon={faSitemap}
          title={t("dashboard.noData")}
          text={t("dashboard.noTcrData") || "No TCR cash balance data available"}
          compact
        />
      )}
    </div>
  );
};

export default TcrCashBalance;
